/**
 * Niet in het origineel: de hartslag. Een scherm stuurt af en toe deze kale tekst (geen
 * JSON) en krijgt `PONG` terug. De runtime antwoordt zelf (`setWebSocketAutoResponse`),
 * dus het spel hoeft er niet voor wakker te worden. Komt er niets terug, dan is de
 * verbinding dood, ook als de browser nog denkt dat hij openstaat.
 */
export const PING = 'ping';
export const PONG = 'pong';
